import { MoreHorizontal, Pencil, Power, Layers, Trash2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const money = (v) =>
  `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function GroupsGrid({ groups, onEdit, onToggleActive, onDelete, readOnly = false }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-auto" data-testid="groups-table">
      <table className="w-full text-xs">
        <thead className="bg-slate-50 sticky top-0">
          <tr>
            {["Group", "Category", "Items", "Total Unit Cost", "Total Labor Hrs", "Default Cost Code",
              "Version", "Active", ""].map((h) => (
              <th key={h} className="px-3 py-2 text-left font-medium text-slate-500 whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {groups.length === 0 && (
            <tr><td colSpan={9} className="px-3 py-10 text-center text-slate-400">
              No groups yet — use "+ Add Group" to bundle items into a reusable group.
            </td></tr>
          )}
          {groups.map((g) => (
            <tr key={g.id} className={`border-t border-slate-100 hover:bg-slate-50/70 ${g.active ? "" : "opacity-50"}`}
                data-testid={`group-row-${g.id}`}>
              <td className="px-3 py-1.5">
                <div className="flex items-center gap-1.5 text-slate-800">
                  <Layers className="h-3.5 w-3.5 text-slate-400" />{g.name}
                </div>
                {g.description && <div className="text-[10px] text-slate-400 truncate max-w-[280px]">{g.description}</div>}
              </td>
              <td className="px-3 py-1.5 text-slate-600">{g.category || "—"}</td>
              <td className="px-3 py-1.5 text-slate-600">{g.item_count}</td>
              <td className="px-3 py-1.5 text-slate-800">{money(g.total_unit_cost)}</td>
              <td className="px-3 py-1.5 text-slate-600">{g.total_labor_hours}</td>
              <td className="px-3 py-1.5 font-mono text-slate-600">{g.default_cost_code || "—"}</td>
              <td className="px-3 py-1.5 text-slate-500">v{g.version}</td>
              <td className="px-3 py-1.5">{g.active ? "Yes" : "No"}</td>
              <td className="px-1">
                {!readOnly && <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button className="p-1 rounded hover:bg-slate-200 text-slate-500"
                            data-testid={`group-actions-${g.id}`}>
                      <MoreHorizontal className="h-4 w-4" />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => onEdit(g)} data-testid={`group-action-edit-${g.id}`}>
                      <Pencil className="h-3.5 w-3.5 mr-2" /> Edit
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => onToggleActive(g)} data-testid={`group-action-active-${g.id}`}>
                      <Power className="h-3.5 w-3.5 mr-2" /> {g.active ? "Deactivate" : "Reactivate"}
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => onDelete(g)} className="text-red-600"
                                      data-testid={`group-action-delete-${g.id}`}>
                      <Trash2 className="h-3.5 w-3.5 mr-2" /> Delete
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
